/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("classic.solution", require("./rawicons/classic.icon.svg"));
IconRegistry.registerIcon("cda.solution", require("./rawicons/configDriftAndAudit.icon.svg"));
IconRegistry.registerIcon("device.solution", require("./rawicons/device.icon.svg"));
IconRegistry.registerIcon("fileserver.solution", require("./rawicons/fileServer.icon.svg"));
IconRegistry.registerIcon("workflow.solution", require("./rawicons/workflow.icon.svg"));
IconRegistry.registerIcon("help.solution", require("./rawicons/help.icon.svg"));
IconRegistry.registerIcon("settings.solution", require("./rawicons/settings.icon.svg"));
IconRegistry.registerIcon("osm.solution", require("./rawicons/OsManager.icon.svg"));
IconRegistry.registerIcon("dataexport.solution", require("./rawicons/dataexport.icon.svg"));
IconRegistry.registerIcon("schedules.solution", require("./rawicons/schedules.icon.svg"));
IconRegistry.registerIcon(
    "solutionmanager.solution",
    require("./rawicons/solutionsManager.icon.svg")
);
IconRegistry.registerIcon("dashboard.solution", require("./rawicons/dashboard.icon.svg"));
IconRegistry.registerIcon("dataexplorer.solution", require("./rawicons/dataExplorer.icon.svg"));
IconRegistry.registerIcon("rpa.solution", require("./rawicons/rpa.icon.svg"));
IconRegistry.registerIcon("genAi.solution", require("./rawicons/genAi.icon.svg"));
IconRegistry.registerIcon("genAi.solution.disabled", require("./rawicons/genAi.disabled.icon.svg"));
